import WidgetPlaceholder from "./WidgetPlaceholder";
import DashboardTable from "../table/DashboardTable";
import DownloadOptionsMenu, {
  type WidgetDownloadOptions,
} from "./DownloadOptionsMenu";

type DataRow = Record<string, unknown>;

type DataTableEnvelope = {
  data?: DataRow[];
  has_download_options?: boolean;
  download_options?: WidgetDownloadOptions;
};

type DataTableWidgetProps = {
  isLoading: boolean;
  data: unknown;
  title?: string;
  dashboardName?: string;
  widgetTemplateId?: string | number;
  appliedFilters?: Record<string, unknown>;
};

// WidgetRenderer now keeps the full envelope for data_table (so
// has_download_options/download_options survive), but the builder preview
// path (Slot.tsx) still sends the bare rows array — handle both.
const unwrap = (raw: unknown): DataTableEnvelope => {
  if (Array.isArray(raw)) return { data: raw as DataRow[] };
  if (raw && typeof raw === "object") return raw as DataTableEnvelope;
  return {};
};

export default function DataTableWidget({
  isLoading,
  data,
  title,
  dashboardName,
  widgetTemplateId,
  appliedFilters,
}: DataTableWidgetProps) {
  const parsed = unwrap(data);
  const reportData: DataRow[] = parsed.data ?? [];
  const reportHeader = reportData[0] ? Object.keys(reportData[0]) : [];

  return isLoading ? (
    <WidgetPlaceholder height={48} />
  ) : (
    <>
      <DownloadOptionsMenu
        menuId={
          widgetTemplateId !== undefined ? String(widgetTemplateId) : undefined
        }
        title={title}
        dashboardName={dashboardName}
        widgetTemplateId={widgetTemplateId}
        appliedFilters={appliedFilters}
        downloadOptions={
          parsed.has_download_options ? parsed.download_options : undefined
        }
      />
      <DashboardTable
        isReportLoading={isLoading}
        reportHeader={reportHeader}
        reportData={reportData}
      />
    </>
  );
}
